import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../components/widgets/Select';
import css from './KpiHeaderComponent.css';

const KpiHeaderComponent = ({ progressSort, column, enableSorting, onKpiChange, selectedKpi, kpiColumns }) => {
    const [sortState, setSortState] = React.useState(null);

    const handleChange = option => option && onKpiChange(option.value);

    const onSortRequested = () => {
        progressSort();
        const sort = column.getSort();
        setSortState(sort);
    };

    let sortIcon = '⇅';
    if (enableSorting && column) {
        if (sortState === 'asc') {
            sortIcon = '↑';
        } else if (sortState === 'desc') {
            sortIcon = '↓';
        }
    }

    const selectedKpiOption = { value: selectedKpi, label: selectedKpi };
    const availableKpiOptions = kpiColumns.map(option => ({ value: option, label: option }));

    return (
        <div className={css.headerContainer}>
            <Select
                value={selectedKpiOption}
                options={availableKpiOptions}
                onChange={handleChange}
                isSearchable={false}
                menuPortalTarget={document.body}
                styles={{
                    container: base => ({ ...base, width: '100%' }),
                    control: base => ({
                        ...base,
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none',
                        minHeight: '24px',
                        padding: 0,
                        '&:hover': {
                            border: 'none',
                            boxShadow: 'none',
                        },
                    }),
                    valueContainer: base => ({
                        ...base,
                        padding: '0 4px',
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                    dropdownIndicator: base => ({
                        ...base,
                        padding: '0 4px',
                    }),
                    option: base => ({ ...base, fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden' }),
                }}
            />
            {enableSorting && progressSort && (
                <div className={css.sortContainer} onClick={onSortRequested} role="button" tabIndex={0}>
                    <span className={css.sortIcon}>{sortIcon}</span>
                </div>
            )}
        </div>
    );
};

KpiHeaderComponent.propTypes = {
    progressSort: PropTypes.func,
    column: PropTypes.object,
    enableSorting: PropTypes.bool,
    onKpiChange: PropTypes.func.isRequired,
    selectedKpi: PropTypes.string.isRequired,
    kpiColumns: PropTypes.array.isRequired,
};

export default KpiHeaderComponent;
